import { useState, useEffect, useRef } from 'react';
import { withStyles } from '@material-ui/core';
import Timer from './Timer';
import appConstants from '../../../../../appConstants';
import { Optimization_Timer_Label } from '../constants';
import Events from '../../../../../utilities/EventEmitter';
import { APP_EVENT_NAMES } from '../../../../../signalR/constants';
const { IBPLANNING } = APP_EVENT_NAMES;

const styles = () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    marginBottom: 40
  }
});

const RouteTimer = ({
  classes,
  updateOptimizationRunTime,
  progressPercentage = 0
}) => {
  const [queuedTime, setQueuedTime] = useState(0);
  const [runTime, setRunTime] = useState(0);
  let timerRef = useRef(null);

  const startQueueTimer = () => {
    return setInterval(() => {
      setQueuedTime((prevQueueTime) => prevQueueTime + 1);
    }, appConstants.ONE_SECOND_TIME_OUT);
  };

  const startOptimizationTimer = () => {
    return setInterval(() => {
      setRunTime((prevRunTime) => prevRunTime + 1);
    }, appConstants.ONE_SECOND_TIME_OUT);
  };

  const onDynamicRoutingCompleted = (...args) => {
    const [,isSuccess,,,,percentCompleted] = args;
    if (!isSuccess || !percentCompleted) { //if optimization failed or succeeded with no percentCompleted value stop the timer
      clearInterval(timerRef);
      updateOptimizationRunTime(queuedTime, runTime);
    }
  };

  useEffect(() => {
    Events.on(IBPLANNING.RoutingStatus, onDynamicRoutingCompleted);
    if (progressPercentage < 1) {
      timerRef = startQueueTimer();
    } else {
      clearInterval(timerRef);
      timerRef = startOptimizationTimer();
    }

    return () => {
      clearInterval(timerRef);
      Events.off(IBPLANNING.RoutingStatus, onDynamicRoutingCompleted);
    };
  }, [progressPercentage]);

  return (
    <div className={classes.container}>
      {progressPercentage > 0 && (
        <Timer label={Optimization_Timer_Label.runTimeLabel} timeInSeconds={runTime} />
      )}
      <Timer
        label={Optimization_Timer_Label.queuedLabel}
        timeInSeconds={queuedTime}
        useNormalStyle={runTime}
      />
    </div>
  );
};

export default withStyles(styles)(RouteTimer);
